import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import { createXlsxDetail } from "./detail";

export async function generateFile({
  reportData = [],
  reportType = "",
  optionData = {},
  finishAction = () => {},
} = {}) {
  const workbook = new ExcelJS.Workbook();

  createXlsxDetail({
    title: "問卷資料",
    data: {
      workbook,
      reportType,
      reportData,
      optionData,
    },
  });

  // 清冊範例 excel
  const mainBuffer = await workbook.xlsx.writeBuffer();
  const mainFileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const mainBlob = new Blob([mainBuffer], { type: mainFileType });

  saveAs(mainBlob, `${optionData.question_title[reportType]}.xlsx`);
  finishAction();
}
